import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

const BasicModal = ({ ...props }) => {
  BasicModal.propTypes = {
    show: PropTypes.bool.isRequired,
    hideModal: PropTypes.func.isRequired,
    onOk: PropTypes.func,
    title: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.element
    ]),
    children: PropTypes.arrayOf(PropTypes.element).isRequired,
    showCloseButton: PropTypes.bool,
    dialogClassName: PropTypes.string,
    OkButtonText: PropTypes.string,
    CancelButtonText: PropTypes.string
  };

  return (
    <Modal show={props.show} onHide={props.hideModal} centered dialogClassName={props.dialogClassName}>
      {
        props.title &&
        <Modal.Header closeButton={props.showCloseButton}>
          <Modal.Title>
            {props.title}
          </Modal.Title>
        </Modal.Header>
      }
      <Modal.Body>
        {props.children}
      </Modal.Body>
      {
        (props.OkButtonText || props.CancelButtonText) && <Modal.Footer>
          {
            props.CancelButtonText &&
            <button className='btn btn-link text-muted' onClick={props.hideModal} >{props.CancelButtonText}</button>
          }
          {
            props.OkButtonText &&
              <button className='btn btn-link text-primary' onClick={() => { props.onOk(); props.hideModal(); }}>{props.OkButtonText}</button>
          }
        </Modal.Footer>
      }
    </Modal>
  );
};

export default BasicModal;
